function LastContact() {
    "use strict";

    this.Id = -1;
    this.DeviceId = -1;
    this.TrackDate = null;
    this.Latitude = 0.00;
    this.Longitude = 0.00;
    this.Speed = 0;
    this.Direction = 0;
    this.BatteryLevel = -1;
    this.BatteryVoltage = 0.00;
    this.ContactDate = null;
    this.Status = -1;
    this.DeviceVersion = 0;
    this.RecordCount = 0;
    this.GpsRecordCount = 0;
    this.PercentGps = 0;
}
if (typeof exports !== 'undefined') {
    module.exports = LastContact;
}